import Url from 'url-parse';
import Qs from 'qs';
import { carKinds, SD_IMMUTABLE_FIELD } from '../constants';

Date.prototype.format = function (format) {
    var o = {
        "M+": this.getMonth() + 1, //month
        "d+": this.getDate(), //day
        "h+": this.getHours(), //hour
        "m+": this.getMinutes(), //minute
        "s+": this.getSeconds(), //second
        "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
        "S": this.getMilliseconds() //millisecond
    }
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o) if (new RegExp("(" + k + ")").test(format))
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    return format;
};

window.recordSwitch = true; // 视频录制开关 默认开 前端管控

function pad(n) {
    return n < 10 ? `0${n}` : n;
}

export const getIdCardInfo = (cardNo) => {
    let now = new Date();
    let year = now.getFullYear(),
        month = now.getMonth() + 1,
        day = now.getDate();
    let sex = "01",
        birthday = year + "-" + month + "-" + day,
        age = 0;
    if (cardNo.length === 15) {
        let re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
        let arr_data = cardNo.match(re_fifteen);
        year = "19" + arr_data[2];
        month = arr_data[3];
        day = arr_data[4];
        //获取性别
        if (parseInt(cardNo.substr(14, 1)) % 2 === 1) {
            //男
            sex = "01";
        } else {
            //女
            sex = "02";
        }
    } else if (cardNo.length === 18) {
        //获取出生日期
        year = cardNo.substring(6, 10);
        month = cardNo.substring(10, 12);
        day = cardNo.substring(12, 14);
        if (parseInt(cardNo.substr(16, 1)) % 2 === 1) {
            //男
            sex = "01";
        } else {
            //女
            sex = "01";
        }
    }

    birthday = year + "-" + month + "-" + day;

    let myDate = new Date();
    let myMonth = myDate.getMonth() + 1;
    let myDay = myDate.getDate();
    age = myDate.getFullYear() - year - 1;
    if (month < myMonth || (month === myMonth && day <= myDay)) {
        age++;
    }
    return {
        age: age,
        sex: sex,
        birthday: birthday,
    };
};

export const yearsBetween = (...param) => {
    let [day1, day2, y] = [...param];
    let arrD2 = "";
    let myDate = "";
    let splitFormat = "-";
    let byYear = y;

    if (param.length === 1) {
        myDate = new Date();
        arrD2 = param[0].split(splitFormat);
    } else {
        if (typeof day1 == "string" && typeof day2 == "string") {
            myDate = new Date(day1.replace(/-/g, '/'));
            arrD2 = day2.split(splitFormat);
        } else if (typeof day1 == "string" && typeof day2 == "boolean") {
            myDate = new Date();
            arrD2 = day1.split(splitFormat);
            byYear = day2;
        } else {
            return;
        }
    }
    var month = myDate.getMonth() + 1;
    var day = myDate.getDate();
    if (byYear) {
        return myDate.getFullYear() - arrD2[0];
    }
    var age = myDate.getFullYear() - arrD2[0] - 1;
    if (arrD2[1] < month || (arrD2[1] == month && arrD2[2] <= day)) {
        age++;
    }
    return age;
};

export const beautyFormatDate = (d, format) => {
    let tmpD = d;
    if (!d) {
        return '--';
    }
    if (typeof tmpD === 'string') {
        tmpD = tmpD.replace(/[-]/g, '/');
    }
    const targetDate = new Date(tmpD);
    const year = targetDate.getFullYear();
    const month = pad(targetDate.getMonth() + 1);
    const date = pad(targetDate.getDate());
    const hours = pad(targetDate.getHours());
    const minutes = pad(targetDate.getMinutes());
    const seconds = pad(targetDate.getSeconds());

    const tmplMap = {
        'yyyy-mm-dd,hh:mm': `${year}-${month}-${date},${hours}:${minutes}`,
        'yyyy-mm-dd hh:mm': `${year}-${month}-${date} ${hours}:${minutes}`,
        'yyyy-mm-dd': `${year}-${month}-${date}`,
        yyyymmdd: `${year}${month}${date}`,
        'yyyy-mm-dd hh:mm:ss': `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`,
        'yyyy*mm*dd hh:mm:ss': `${year}年${month}月${date}日 ${hours}:${minutes}:${seconds}`,
        'mm-dd hh:mm': `${month}-${date} ${hours}:${minutes}`,
        'mm-dd hh:mm:ss': `${month}-${date} ${hours}:${minutes}:${seconds}`,
        'hh:mm:ss': `${hours}:${minutes}:${seconds}`,
    };
    if (format in tmplMap) {
        return tmplMap[format];
    }
    return '--';
};

export const stringParsedTime = (dateTimeStr) => {
    const temp = dateTimeStr.split(' ');
    const tempD = temp[0].split(/-|\//);
    const tempT = temp[1].split(':');
    return new Date(tempD[0], tempD[1] - 1, tempD[2], tempT[0], tempT[1], tempT[2]);
};
// 求今天
export const recTodayDate = () => {
    const nex = new Date();
    const nexDate = beautyFormatDate(nex, 'yyyy-mm-dd');
    return beautyFormatDate(`${nexDate} 00:00:00`, 'yyyy-mm-dd hh:mm:ss');
};

// 求明天
export const recNexDate = () => {
    const nex = new Date();
    nex.setDate(nex.getDate() + 1);
    const nexDate = beautyFormatDate(nex, 'yyyy-mm-dd');
    return beautyFormatDate(`${nexDate} 00:00:00`, 'yyyy-mm-dd hh:mm:ss');
};
// 对参数时间 +1 天
export const recNexDateSpecial = (timeStr) => { // timeStr 为 2018-12-12  格式
    const nex = new Date(timeStr.replace(/[-]/g, '/'));
    nex.setDate(nex.getDate() + 1);
    const nexDate = beautyFormatDate(nex, 'yyyy-mm-dd');
    return beautyFormatDate(`${nexDate} 00:00:00`, 'yyyy-mm-dd hh:mm:ss');
};
//添加increment年
export const addYear = (date, increment) => {
    date = typeof date === 'string' ? date.replace(/[-]/g, '/') : date;
    let d = new Date(date);
    d.setFullYear(d.getFullYear() + (increment || 1));
    return d;
}

export const addDay = (date, increment) => {
    date = typeof date === 'string' ? date.replace(/[-]/g, '/') : date;
    let d = new Date(date);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() + increment, d.getHours(), d.getMinutes(), d.getSeconds());
}
/**
     * 根据起期计算止期
     * @param startT 起期
     * 长期险：T+1 | 即时起保 两种
     *  T+1
     *   商业险 2020-06-19 00:00:00 2021-06-18: 23:59:59
     *   交强险 2020-06-19 00:00:00 2021-06-18: 23:59:59
     *
     *  即时起保
     *   商业险 2020-06-18 10:00:00 2021-06-18: 23:59:59
     *   交强险 2020-06-18 10:00:00 2021-06-18: 10:00:00
     */
export const countEndDate = (startT,type) => {
    let sfm = startT.split(" ")[1]; //时分秒
    let endT = format(addYear(startT, 1), 'yyyy-MM-dd 23:59:59');

    if (type === 'sy') {                    //商业险
        if (sfm === '00:00:00') {           //T+1
            endT = addDay(endT, -1);
        } else {                            //即时起保
            //商业险即时起保就是这样，不用修改
        }

    } else {                               //交强险
        if (sfm === '00:00:00') {          //T+1
            endT = addDay(endT, -1);
        } else {                           //即时起保
            let nyr = endT.split(" ")[0];  //年月日
            endT = format(new Date((nyr + ' ' + sfm).replace(/[-]/g, '/')), 'yyyy-MM-dd hh:mm');
        }
    }
    return format(endT,'yyyy-MM-dd hh:mm:ss');
}
export const format = (date, format) => {
    date = typeof date === 'string' ? date.replace(/[-]/g, '/') : date;
    date = new Date(date);
    let o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(),      //day
        "h+": date.getHours(),     //hour
        "m+": date.getMinutes(),   //minute
        "s+": date.getSeconds(),   //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        "S": date.getMilliseconds() //millisecond
     }
     if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
     for (var k in o)if (new RegExp("(" + k + ")").test(format))
        format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
     return format;
}
export const deepClone = object => JSON.parse(JSON.stringify(object));

export const nullOrStringify = (value) => {
    if (value !== null) {
        return `${value}`;
    }
    return value;
};

export const isWeiXin = () => {
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    }
    return false;
};
/**
 *   格式化报价金额，保留几位小数(toFixed是五舍六入)，默认是两位小数，返回的是String类型
 *   premium: 要处理的数值，必选，数值或字符串类型，如：45.62或"45.62";
 *   format:  保留的小数位，可选，整数，默认是2，保留两位小数。
 *   autoNumber : 是否强制parseFloat返回，有的话，则为转化成数值类型，但这样的话类似1.00会转成1，去掉了小数点后的00
 */
export const formatPremium = (premium, format, autoNumber) => {
    var newPre = (new Number(premium)).toFixed(format || (format == 0 ? 0 : 2));
    return autoNumber ? Number(newPre) : newPre;
};
/**
 *  计算两个字符串日期之间相差的天数
 */
export const daysBetween = (day1, day2, splitFormat) => {
    if (typeof day1 == 'string' && typeof day2 == 'string') {
        splitFormat = splitFormat ? splitFormat : "-";
        var arrD1 = day1.split(splitFormat);
        var arrD2 = day2.split(splitFormat);
        if (arrD1 && arrD2) {
            var oDay1 = new Date(arrD1[0], arrD1[1] - 1, arrD1[2]);
            var oDay2 = new Date(arrD2[0], arrD2[1] - 1, arrD2[2]);
            var days = (oDay1.getTime() - oDay2.getTime()) / (1000 * 60 * 60 * 24);
            return formatPremium(days, 0);
        }
    }
};
//转换时间
/**
 * flag: 时间是否只到分 保留年月日
 * */
export const translateTimeDate = (timeStr, flag) => {
    var len = timeStr.length;
    var newDate = new Date(timeStr.replace(/[-]/g, '/'));
    var newTime;
    if (len == 10) {//2018-09-03
        newDate = new Date(timeStr.replace(/[-]/g, '/'));
        if (flag) {
            newTime = newDate.format('yyyy-MM-dd 00:00');
        } else {
            newTime = newDate.format('yyyy-MM-dd');
        }

    } else if (len == 13) {//2018-09-03 00
        newDate = new Date((timeStr + ":00:00").replace(/[-]/g, '/'));
        if (flag) {
            newTime = newDate.format('yyyy-MM-dd hh:00');
        } else {
            newTime = newDate.format('yyyy-MM-dd');
        }
    } else if (len == 16) {//2018-09-03 00:00
        newDate = new Date((timeStr + ":00").replace(/[-]/g, '/'));
        if (flag) {
            newTime = newDate.format('yyyy-MM-dd hh:mm');
        } else {
            newTime = newDate.format('yyyy-MM-dd');
        }
    } else if (len == 19) {//2018-09-03 00:00:00
        newDate = new Date(timeStr.replace(/[-]/g, '/'));
        if (flag) {
            newTime = newDate.format('yyyy-MM-dd hh:mm');
        } else {
            newTime = newDate.format('yyyy-MM-dd');
        }
    }

    return newTime;
};

//引入腾讯定位API
export function qqMapGeolocation() {
    //   Loading.show();
    return new Promise(function (resolve, reject) {
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://apis.map.qq.com/tools/geolocation/min?key=KW7BZ-3KQ3U-N2HVC-BOJYT-AIBC5-K7BAI&referer=claim";
        script.onerror = reject;
        script.onload = function () {
            resolve()
        };
        document.head.appendChild(script);
    })
};

//将省市区name转换成value的方法
export function name2value(province, city, area, addressData) {
    let address = [];
    let errMsg = '';
    let flag = true;
    if (addressData.length == 0) {
        return { address: address, errMsg: '地址尚未完全载入，请稍后再定位', flag: false }
    }

    [province, city, area].forEach((direct, index) => {
        let tmp = addressData.filter(item => {
            if (index > 0) {
                return item.name.indexOf(direct) != -1 && item.parent == address[index - 1];
            } else {
                return item.name.indexOf(direct) != -1 && !item.parent  //没有parent
            }
        });
        if (tmp.length != 0) {
            address.push(tmp[0].value);
        } else {
            errMsg = '定位地址可能存在误差，请手动定位';
            flag = false;
            address.push('');
        }
    });
    return { address: address, errMsg: errMsg, flag: flag }
};

export function mergeObj(old, current, obj) {
    for (let i in old) {
        if (current[i]) {
            obj[i] = current[i];
        } else {
            obj[i] = old[i];
        }
    }
    return obj
}

export function mergeObj2(old, current) {
    let obj = {};
    for (let i in old) {
        // if(i== 'taxType')debugger;
        if (current[i]) {
            obj[i] = current[i];
        } else {
            obj[i] = old[i];
        }
    }
    // 查漏  current中存在    old中不存在
    for (let node in current) {
        if (typeof old[node] == 'undefined') {
            obj[node] = current[node];
        }
    }
    return obj
};

// 合并carBeans
export function mergeCarBeans(old, current) {
    let newCarBeans = {};
    let busiAttrConfig = {};
    let node;
    for (node in current) {
        if (node == 'base') {
            // 多层单独处理
            busiAttrConfig = mergeObj2(old[node]["busiAttrConfig"], current[node]["busiAttrConfig"]);
            newCarBeans[node] = mergeObj2(old[node], current[node]);
            newCarBeans[node].busiAttrConfig = busiAttrConfig;
        } else if (['appConfig', 'owner', 'applicant', 'insured', 'vehicle'].indexOf(node) != -1 && current[node]) {
            newCarBeans[node] = mergeObj2(old[node], current[node]);
        } else {
            newCarBeans[node] = current[node];
        }
    }
    return newCarBeans;
};

/**
 * 合并车辆信息:
 * @param {*} platformData 山东营运车平台返回的车辆信息,不可修改限制字段的值(SD_IMMUTABLE_FIELD内定义的),其他,有值的字段使用平台数据,无值的字段则用查车数据填充
 * @param {*} vehicle 查车返回的车辆信息
 * @param {*} base  constant.js中的基础车辆信息，防止字段缺失
 * @returns 
 */
export function mergeVehicle(platformData, vehicle, base) {
    for (let key in platformData) {
        if (SD_IMMUTABLE_FIELD.includes(key)) {
            base[key] = platformData[key];
        } else if (platformData[key] || platformData[key] === 0 || platformData[key] === false) {
            base[key] = platformData[key];
        } else {
            base[key] = vehicle[key];
        }
    }
    return base;
}

// 最多保留2位小数  传值小于等于2位小数:不处理  大于等于3位: 截取
export function limitToPercent(val) {
    let index = val.indexOf('.');
    if (val.indexOf('.') != -1 && index < val.length - 3) {
        return Number(val.substr(0, index + 3));
    } else {
        return Number(val);
    }
};

//初登日期格式化
export const formatSingeinDate = date => {
    date = date + '';
    if (typeof date !== 'string') {
        return '';
    }
    // 格式化返回的日期格式：如xxxxxx-xx，xxxx-xxxx等
    date = date.split(' ')[0].replace(/(-|\/)/g, '');
    return date.length === 8 ? date.substr(0, 4) + '-' + date.substr(4, 2) + '-' + date.substr(6, 2) : '';
};

//去除首尾空格
export const textTrim = data => {
    if (typeof data === 'string') {
        return data.trim();
    } else if (data instanceof Object && !(data instanceof Array)) {
        for (var prop in data) {
            if (data[prop] && typeof data[prop] === 'string') {
                data[prop] = data[prop].trim();
            }
        }
        return data;
    } else {
        return data;
    }
};

export const startVideo = (isFirst, flowId, callback) => {//isFirst是否为第一个视频,flowId流程Id,callback回调函数
    if (!window.recordSwitch) {
        return;
    }
    let initParams = {
        env: window.location.host == 'm.sinosafe.com.cn' ? 'prd' : 'test',
    };
    if (isFirst === 1) {
        initParams.first = 1;
        initParams.taskId = flowId;
    }
    console.log('startRecord入参为:', initParams)
    try {
        const startRecordRes = SituRecorder.startRecord(initParams);
        callback && callback(startRecordRes.code === 10000)
    } catch (error) {
        console.log("录屏插件异常：", error);
    }

}
/** 
* 结束录制
*/
export const stopVideo = (flowId, proposalNo) => {
    if (!window.recordSwitch) {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    }
    var data = {
        last: 0, // 是否为最后一个视频，1=是，0=否
        orderInfo: {}, // 投保单信息
    }
    data.orderInfo.orderId = flowId;
    if (proposalNo) data.orderInfo.insuranceNo = proposalNo
    console.log('停止录制,入参为：', data)
    try {
        return SituRecorder.stopRecord(data)
    } catch (error) {
        console.log("录屏插件异常：", error);
    }

};

/**
* 记录流程节点
* type操作类型(必传):LOAD_PAGE载入页面,CLICK_ENTER 点击输入,CLICK_BUTTON 点击按钮,CLICK_SELECT 点击选中,CLICK_CLOSE 点击关闭
* description操作描述(必传)
*/
export const createOperationVideo = (type, description) => {
    if (!window.recordSwitch) {
        return
    }
    let data = {
        type: type,
        description: description
    }
    console.log('记录流程节点入参：', data)
    try {
        SituRecorder.createOperation(data).then(function (res) {
            console.log('记录流程节点返回值:code', res.code, ' msg:', res.msg)
        })
    } catch (error) {
        console.log("录屏插件异常：", error);
    }

};

export const isInNewApp = () => {
    return window.isWebview && window.Capacitor
}

export const isInOldApp = () => {
    return window.isWebview && !window.Capacitor
}

export const isOldAppPage = (pathname) => {
    return pathname === '/eb-web/new-www/index.html'
}

export const isNewAppPage = (pathname) => {
    if (!isInNewApp()) {
        //新app内
        return pathname === '/'
    } else {
        //网页端
        return pathname === '/eb-web/new-app/'
    }
}

export const isInApp = () => {
    return window.isWebview
}

export const isFromNewApp = () => {
    return window.sessionStorage.getItem('isNewYdzy')
}

export const oneClickRenewal = (policyInfo) => {
    //todo优化考虑全民优保
    let { policyNo, licenseNo, riskType, renewalAddr } = policyInfo;

    if (riskType !== '1') {
        if (window.isWebview) {
            webviewAction({
                name: 'openWebview',
                params: {
                    url: renewalAddr,
                    shareFlag: false
                }
            })
        } else {
            window.location.href = renewalAddr;
        }
    } else {
        let Qrenewal = !!(policyInfo.attachnatnme == '个人' && policyInfo.usenaturenme == '非营业' && policyInfo.seatcount < 9 && policyInfo.carkindcodeshownme.indexOf('客车') >= 0);
        // 跳转H5快速续保，信息不全查询保单后再判断。。。
        if (window.isWebview) {
            webviewAction({
                name: 'oneClickRenewal',
                params: {
                    policyNo,
                    licenseNo,
                    Qrenewal
                }
            })
        } else {
            let renewalUrl;
            if (isFromNewApp()) {
                if (!isInNewApp()) {
                    //新app内
                    renewalUrl = `/#/oneClickRenewal?policyNo=${policyNo}&licenseNo=${licenseNo}&Qrenewal=${Qrenewal}`
                } else {
                    //网页端
                    renewalUrl = `/eb-web/new-app/#/oneClickRenewal?policyNo=${policyNo}&licenseNo=${licenseNo}&Qrenewal=${Qrenewal}`
                }
            } else {
                renewalUrl = `/eb-web/new-www/index.html#/oneClickRenewal?policyNo=${policyNo}&licenseNo=${licenseNo}&Qrenewal=${Qrenewal}`
            }
            window.location.href = renewalUrl
        }
    }
}

/**
 * 格式化银行卡4位以空格分割：6226 7401 2507
 * @param card 银行卡号
 * @param separator 分隔符 默认为空格
 */
export const formatYhCard = (card, separator = ' ') => {
    card = card + ''
    let len = card.length
    let s = ''
    if (len > 4) {
        let i = 0
        let sl = 0
        while (sl < len) {
            s = s + card.substr(sl, 4) + (sl + 4 < len ? ' ' : '')
            i++
            sl = i * 4
        }
    } else {
        s = card
    }
    return s
}

export const hideToolbar = () => {
    if (isInNewApp()) {
        if (window.Handler && window.Handler.action) {
            window.Handler.action("hideToolbar", '{}')
        } else {
            window.action("hideToolbar", '{}')
        }
    }
}

export const showToolbar = () => {
    if (isInNewApp()) {
        if (window.Handler && window.Handler.action) {
            window.Handler.action("showToolbar", '{}')
        } else {
            window.action("showToolbar", '{}')
        }
    }
}

export const webviewAction = (options) => {
    // 重构App中展示头部导航直接跳转链接
    if (options.name === 'openWebview' && isInNewApp() && window.Capacitor.platform === 'android') {
        window.location.href = options.params.url
    } else {
        if (window.Handler && window.Handler.action) {
            window.Handler.action("webviewAction", JSON.stringify(options))
        } else if (window.action) {
            window.action("webviewAction", JSON.stringify(options))
        }
    }
}

export const webviewGoBack = (reload = false, topage = '') => {
    if (window.isWebview) {
        webviewAction({
            name: 'closeWebview',
            params: {
                reload,
                topage
            }
        })
    } else {
        history.go(-1);
    }
}

const getSlsInfo = () => {
    let slsInfo = window.sessionStorage.getItem('SLS_INFO') || '{}';
    return JSON.parse(slsInfo);
}

export const openHuiyuanchengzhang = (url, vm) => {
    url = url.replace('http:', 'https:');
    if (window.isWebview) {
        webviewAction({
            name: 'openIframe',
            params: {
                iframeBox: window.location.protocol + '//' + window.location.host + window.location.pathname + '#/iframe/',
                url,
            }
        })
    } else {
        let slsInfo = getSlsInfo();
        if (slsInfo && slsInfo.employCode) {
            let employCode = slsInfo.employCode;
            if (url.indexOf('?') < 0) {
                url = url + '?';
            }
            let phone = slsInfo.phone;
            let plat = slsInfo.plat;
            let salesmanCname = slsInfo.salesmanCname;
            let sign = slsInfo.sign;
            let deptCode = slsInfo.deptCode;
            url = url + '&mobile=' + phone + '&nick=' + salesmanCname + '&plat=' + plat + '&plat_user_id=' + employCode + '&sign=' + sign + '&deptcode=' + deptCode;
        }
        vm.$router.push({
            name: 'iframe',
            query: {
                url,
            }
        })
    }
}

export const webviewMyPerformance = ({ type, month }) => {
    if (isInNewApp() || isFromNewApp()) {
        nativeOpenPage(`/eb-web/new-app/#/myPerformance?TYPE=${type}&month=${month}`)
        return
    }
    if (window.isWebview) {
        webviewAction({
            name: 'trackRecord',
            params: {}
        })
    } else {

    }
}


export const webviewOrderList = () => {
    if (isInNewApp() || isFromNewApp()) {
        nativeOpenPage(`/eb-web/new-app/#/orderList?type=2`)
        return
    }
    if (window.isWebview) {
        webviewAction({
            name: 'oderList',
            params: {}
        })
    } else {

    }
}

export const webviewCheckIn = (params) => {
    if (isInNewApp() || isFromNewApp()) {
        switch (params) {
            case 'index':
                nativeOpenPage(`/eb-web/new-app/#/index`)
                break;
            case 'comp':
                nativeOpenPage(`/eb-web/new-app/#/tool`)
                break;
            case 'mine':
                nativeOpenPage(`/eb-web/new-app/#/mine`)
                break;
            case 'iconMore':
                nativeOpenPage(`/eb-web/new-app/#/icon-more`)
                break;
        }
        return
    }
    if (window.isWebview) {
        webviewAction({
            name: 'checkIn',
            params: {
                id: params,
            }
        })
    } else {
        // 
    }
}

export const webviewPrint = (orderNo) => {
    let query = { type: '3', orderNo: orderNo };
    let hash = '#/orderDetail?query=' + JSON.stringify(query);
    if (isInNewApp() || isFromNewApp()) {
        nativeOpenPage(`/eb-web/new-app/` + hash)
        return
    }
    if (window.isWebview) {
        webviewAction({
            name: 'print',
            params: {
                orderNo,
            }
        })
    } else {
        // todo
    }
}


export const webviewOrderToPay = (orderNo) => {
    if (isInNewApp() || isFromNewApp()) {
        //网页端
        let query = { type: '2', orderNo: orderNo };
        let hash = '#/orderDetail?query=' + JSON.stringify(query);
        nativeOpenPage(`/eb-web/new-app/` + hash)
        return
    }
    if (window.isWebview) {
        webviewAction({
            name: 'orderToPay',
            params: {
                orderNo,
            }
        })
    } else {
        // todo
    }
}

export const webviewPolicyDelivery = (orderNo) => {
    if (isInNewApp() || isFromNewApp()) {
        nativeOpenPage(`/eb-web/new-app/#/orderList?type=3`)
        return
    }
    if (window.isWebview) {
        webviewAction({
            name: 'policyDelivery',
            params: {
                orderNo,
            }
        })
    } else {
        // todo
    }
}

export const nativeAutoLogin = () => {
    if (isInNewApp() || isFromNewApp()) {
        nativeOpenPage(`/eb-web/new-app/#/index`)
        return
    }
    if (window.isWebview) {
        webviewAction({
            name: 'autoLogin',
            params: {}
        })
    }
}

export const suggestions = () => {
    if (isInNewApp() || isFromNewApp()) {
        nativeOpenPage(`/eb-web/new-app/#/feedList`)
        return
    }
    if (window.isWebview) {
        webviewAction({
            name: 'suggestion',
            params: {}
        })
    }
}
export const nativeShare = (options) => {
    if (window.Handler && window.Handler.action) {
        window.Handler.action("sharePay", options);
    } else if (window.action) {
        window.action("sharePay", options);
    }
}
export const assign = (data1, data2) => {
    for (const k in data2) {
        if (data2.hasOwnProperty(k)) {
            let dv = data2[k];
            const type = Object.prototype.toString.call(dv);
            const isAr = type == '[object Array]';
            if (isAr || type == '[object Object]') {
                dv = assign(data1[k] || (isAr ? [] : {}), dv);
            }
            data1[k] = dv;
        }
    }
    return data1;
}
export const assigns = (data, ...datas) => {
    datas.forEach((d, i) => {
        assign(data, d);
    });
    return data;
}

const OLD_NATIVE_ROUTER_PATHS = {
    '#/mit-index': 'tab.mitIndex',
    '#/mit-index-new': 'tab.mitNewIndex',
    '#/mit-icon-more': 'tab.iconMore',
    '#/mit-mine': 'tab.mine',
    '#/sales': 'tab.sales',
    '#/mit-comp': 'tab.comp',
    '#/mit-tools': 'tab.tools',
    '#/mit-config': 'tab.config',
    '#/mit-xbConfig': 'tab.xbConfig',
    '#/mit-config-renewal': 'tab.configRenewal',
    '#/owinfo': 'tab.owinfo',
    '#/owinfoweb': 'tab.owinfoweb',
    '#/carinfo': 'tab.carinfo',
    '#/carModelSelect': 'tab.carModelSelect',
    '#/insuranceSelect': 'tab.insuranceSelect',
    '#/adjustInfo': 'tab.adjustInfo',
    '#/calsDetailsPage': 'tab.calsDetailsPage',
    '#/appPushYjxb': 'tab.appPushYjxb',
    '#/payment': 'tab.payment',
    '#/repeatInsure': 'tab.repeatInsure',
    '#/claimListPage': 'tab.claimListPage',
    '#/owConfirm': 'tab.owConfirm',
    '#/moreInformations': 'tab.moreInformations',
    '#/tianjinTax': 'tab.tianjinTax',
    '#/specialAgreement': 'tab.specialAgreement',
    '#/specialAgreementJd': 'tab.specialAgreementJd',
    '#/draftsList2': 'tab.draftsList2',
    '#/draftsListmore': 'tab.draftsListmore',
    '#/oderSetbacksList': 'tab.oderSetbacksList',
    '#/oderSetbacksDetail': 'tab.oderSetbacksDetail',
    '#/oderSetbacks': 'tab.oderSetbacks',
    '#/imagesFValidate': 'tab.imagesFValidate',
    '#/imagesUpload': 'tab.imagesUpload',
    '#/userFeedBack': 'tab.userFeedBack',
    '#/userFeedList': 'tab.userFeedList',
    '#/aboutAppPage': 'tab.aboutAppPage',
    '#/bindIdCard': 'tab.bindIdCard',
    '#/revokeSelf': 'tab.revokeSelf',
    '#/trackRecord': 'tab.trackRecord',
    '#/trackRecordDetail': 'tab.trackRecordDetail',
    '#/renewal': 'tab.renewal',
    '#/renewalnew': 'tab.renewalnew',
    '#/licensePlate': 'tab.licensePlate',
    '#/validateCarNum': 'tab.validateCarNum',
    '#/policyPrint-A': 'tab.policyPrint-A',
    '#/policyPrint-B': 'tab.policyPrint-B',
    '#/orderDetail-A': 'tab.orderDetail-A',
    '#/policyDelivery': 'tab.policyDelivery',
    '#/policyDeliveryDetail': 'tab.policyDeliveryDetail',
    '#/policySearchNumber': 'tab.policySearchNumber',
    '#/otherPage': 'tab.otherPage',
    '#/otherCPage': 'tab.otherCPage',
    '#/policySearch': 'tab.policySearch',
    '#/policyMoreSearch': 'tab.policyMoreSearch',
    '#/policyDetail': 'tab.policyDetail',
    '#/nocarDetails': 'tab.nocarDetails',
    '#/insureNotice': 'tab.insureNotice',
    '#/motoIndex': 'tab.motoIndex',
    '#/motoInsurance': 'tab.motoInsurance',
    '#/motoOrderno': 'tab.motoOrderno',
    '#/motoCarSearch': 'tab.motoCarSearch',
    '#/oneClickRenewal': 'oneClickRenewal',
    '#/tab/userFeedBack': 'tab.userFeedBack'
}

const NATIVE_ROUTER_PATHS = {
    // New path: Old router name
    '#/myPerformance': 'tab.trackRecord',
}

const mapInvert = (obj) => {
    const result = {}
    const keys = Object.keys(obj)
    for (let key of keys) {
        result[obj[key]] = key
    }
}

const getNewRouterPathByOldRouterPath = (oldRouterPath) => {
    return mapInvert(NATIVE_ROUTER_PATHS)[OLD_NATIVE_ROUTER_PATHS[oldRouterPath]]
}

const getOldRouterPathByNewRouterPath = (newRouterPath) => {
    return mapInvert(OLD_NATIVE_ROUTER_PATHS)[NATIVE_ROUTER_PATHS[newRouterPath]]
}

/**
 * 打开掌上宝内部页面
 * @param {*} url 
 */
export const nativeOpenPage = (url) => {
    if (isInApp()) {
        //掌上宝webview内
        const parsed = Url(url, true);
        let hash = parsed.hash;
        if (isOldAppPage(parsed.pathname) || isNewAppPage(parsed.pathname)) {
            //掌上宝内部页面
            const arr = hash.split('?'), query = arr[1]
            const routerPath = arr[0];
            const routerParams = Qs.parse(query);
            if (isOldAppPage(parsed.pathname)) {
                if (isInNewApp()) {
                    const newRouterPath = getNewRouterPathByOldRouterPath(routerPath)
                    if (!newRouterPath) {
                        console.error('未配置对应路由')
                        return
                    }
                    webviewAction({
                        name: 'jumpInnerRouter',
                        params: {
                            hash: newRouterPath + (query ? ('?' + query) : '')
                        }
                    })
                } else {
                    const routerName = OLD_NATIVE_ROUTER_PATHS[routerPath];
                    if (!routerName) {
                        console.error('未配置对应路由')
                        return
                    }
                    webviewAction({
                        name: 'jumpInnerRouter',
                        params: {
                            routerName,
                            routerParams,
                            routerConfig: {
                                reload: routerParams.reload
                            }
                        }
                    })
                }
            } else {
                if (isInNewApp()) {
                    webviewAction({
                        name: 'jumpInnerRouter',
                        params: {
                            hash,
                        }
                    })
                } else {
                    const routerName = getOldRouterPathByNewRouterPath(routerPath)
                    if (!routerName) {
                        console.error('未配置对应路由')
                        return
                    }
                    webviewAction({
                        name: 'jumpInnerRouter',
                        params: {
                            routerName,
                            routerParams,
                            routerConfig: {
                                reload: routerParams.reload
                            }
                        }
                    })
                }
            }
        } else if (parsed.query.hasNav) {
            // 传参表示有头部导航
            window.location.href = url;
        } else if (parsed.query.needIframe) {
            //因页面无头部，提供Iframe打开
            webviewAction({
                name: 'openIframe',
                params: {
                    iframeBox: window.location.protocol + '//' + window.location.host + window.location.pathname + '#/iframe/',
                    url,
                }
            });
        } else {
            //无头部新开webview
            webviewAction({
                name: 'openWebview',
                params: {
                    url,
                }
            });
        }
    } else {
        window.location.href = url;
    }
}

export const watchPropertyChange = (obj, key, callback) => {
    let val = obj[key]
    Object.defineProperty(obj, key, {
        configurable: true,
        get() {
            return val
        },
        set(newWal) {
            if (val != newWal) {
                val = newWal
                callback(newWal)
            }
        }
    })
}

export const getDateYearSub = (startDateStr, endDateStr) => {
    let day = 24 * 60 * 60 * 1000;
    let year = 365 * day;
    let sDate = new Date(Date.parse(startDateStr.replace(/[-]/g, "/")));
    let eDate = new Date(Date.parse(endDateStr.replace(/[-]/g, "/")));
    let yearsBetween = 0;
    sDate = new Date(sDate.getTime());
    eDate = new Date(eDate.getTime());
    yearsBetween = (eDate - sDate) / year;
    // 向下取整
    return Math.floor(yearsBetween);
}

//引入高德定位API
export const loadAMAP = () => {
    return new Promise(function (resolve, reject) {
        if (typeof AMap !== "undefined") {
            return resolve()
        }
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://webapi.amap.com/maps?v=1.4.15&key=c65d74a0459f385fbc27c6132073294e";
        script.onerror = reject;
        script.onload = function () {
            resolve()
        };
        document.head.appendChild(script);
    })
}

export const transDate = (date) => {
    // 转换中文日期
    let _reg = /(\d+)[年/-](\d+)[月/-](\d+)日?/g;
    let _date = date.replace(_reg, '$1/$2/$3');
    let _res = beautyFormatDate(new Date(_date.replace(/[-]/g, '/')), 'yyyy-mm-dd');
    if (_reg.test(_res)) {
        // 匹配格式成功，返回yyyy-mm-dd格式日期数据
        return _res;
    } else {
        // 匹配不成功，清空
        return '';
    }
}

// 设置车辆得其他字段
const setOtherInfo = (vehicle) => {
    const classId = vehicle.jqxClassId || vehicle.syxClassId
    let carKindCode
    // if (['H', 'L'].includes(classId)) {
    if (isHuoChe(classId)) {
        carKindCode = '200'
    } else {
        carKindCode = '100'
    }
    const seatCountShow = passApproveBlur(carKindCode, vehicle, 'seatCount')
    const tonCountShow = passApproveBlur(carKindCode, vehicle, 'tonCount')
    return {
        carKindCode,
        carKindCodeShow: tonCountShow ? tonCountShow : seatCountShow
    }
}
const passApproveBlur = (code, vehicle, type) => {
    let carKindCodeShow
    const adopt = {
        '100': 'seatCount',
        '200': 'tonCount',
        '300': 'tonCount'
    }
    if (adopt[code] != type) {
        return ""
    }
    let num = vehicle[type]
    if (!isNaN(num)) {
        // self._getCarKindsLimit(code, num, type)
        //营业车，货车挂车载质量；客车载客数 判断区间，并且展示对应的区间的选项
        // ,_getCarKindsLimit:function(code, num, id){
        if (type == 'tonCount') {
            num = num / 1000
            //判断车牌是否以“挂”字结尾 \u6302
            const plateNum = vehicle.licenseNo
            if (plateNum.endsWith('\u6302')) {
                code = '200GUA'
            }
        }
        const obj = carKinds[code]
        // 设置座位数或者重量
        for (const item of obj) {
            if (num > item.limit[0] && item.limit[1] === '') {
                carKindCodeShow = item.value
                break
            }
            if (num >= item.limit[0] && num < item.limit[1]) {
                carKindCodeShow = item.value
                break
            }
        }
    }
    return carKindCodeShow
}
//判断货车 true 是货车 ； false 不是货车
const isHuoChe = (classId) => {
    if (!classId) {
        return ''
    }
    let str = classId + ''
    str = str.charAt(0).toUpperCase()
    return ['H', 'L'].includes(str)
}

// 是否华安保险APP
export const isHaApp = () => !!navigator.userAgent.match(/HaApp|uni-app/ig);

// 230418，地址校验同掌上宝app
export const checkAddress = (opt) => {
    var opts = {
        person: '',
        address: '',
        maxLength: 120,
        minLength: 12,
        limitLength: 60
    }
    var res = {
        chkres: true,
        errmsg: '',
    }
    opts = Object.assign(opts, opt);
    // var notAllowReg = /[\^、\&？\n、.......$￥；”]/;
    //不少于6个汉字或者12个英文字符，长度最多不能超过60个汉字或字符（一个中文2个字节）
    var chinesChar = /[\u4e00-\u9fa5]/; //中文字符
    var l = 0;
    for (var idx = 0; idx < opts.address.length; ++idx) {
        if (chinesChar.test(opts.address[idx])) {
            l += 2;
        } else {
            l++;
        }
    }

    var len = opts.address.length || 0; //不区分中英文字符
    if (len > opts.limitLength) {
        return {
            chkres: false,
            errmsg: opts.person + '地址长度为' + len + '，但是期望的最大长度为' + (opts.limitLength)
        };
    } else if (l < opts.minLength) {
        return {
            chkres: false,
            errmsg: opts.person + '地址不能少于' + (opts.minLength / 2) + '个汉字或' + opts.minLength + '位字符！'
        };
    }
    return res;
}

const VIDEO_TYPE_LIST = ['3gp', 'mp4', 'mov']

//是否为图片后缀
export const isPostfixImg = (mediaPath) => {
    const re1 = /\.([\w]{3,4})$/gi,
        re2 = /FileId=\w+\.([\w]{3,4})&Type=/gi
    const result = re1.exec(mediaPath) || re2.exec(mediaPath)
    const type = result[1]
    return VIDEO_TYPE_LIST.indexOf(type.toLowerCase()) == -1
}
//获取文件后缀
export const getPostFix = (fileName) => {
    const index = fileName.lastIndexOf('.')
    const str = fileName.substring(index + 1) //获取后缀
    return str.toLowerCase()
}

export const checkAuditTime = (startTime, endTime) => {
    // 获取当前时间
    const date = new Date()
    // 获取当前时间的年月日
    const dataStr = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} `

    // 获取开始时间、结束时间、现在时间的时间戳
    let startDate = new Date(dataStr + startTime).getTime()
    let endDate = new Date(dataStr + endTime).getTime()
    let nowDate = date.getTime()

    const s = startDate > endDate // 判断开始时间否大于结束时间

    if (s) [startDate, endDate] = [endDate, startDate] // 若开始时间否大于结束时间则交换值

    // 判断现在的时间是否在开始时间和结束时间之间，若s为true则结果取反
    if (nowDate > startDate && nowDate < endDate) {
        return s ? false : true
    } else {
        return s ? true : false
    }
}

// 判断是微信环境并且微信版本大于7.0.12
export const isEnableOpenWeapp = () => {
    var mathWechatVersion = navigator.userAgent.match(
        /MicroMessenger\/([\d\.]+)/i
    )
    if (mathWechatVersion) {
        var judgewechat = mathWechatVersion[1].split('.')
        if (
            +judgewechat[0] > 7 ||
            (+judgewechat[0] == 7 && +judgewechat[1] > 0) ||
            (+judgewechat[0] == 7 &&
                +judgewechat[1] == 0 &&
                +judgewechat[2] >= 12)
        ) {
            // 微信版本是 7.0.12及以上
            return true
        }
    }
    return false
}

/**
 * 
 * @param {*} newOcrSwitch newocr开关是否打开，为true使用新ocr接口
 * @param {*} card 证件类型 1行驶证  2身份证
 * @returns 
 */
export const getOcrUrlName = (newOcrSwitch, card) => {
    if (!newOcrSwitch) return 'ocrHandle'
    const obj = {
        1: 'vehicleLicenseOcr', // 行驶证
        2: 'idCardOcr', // 身份证
        5: 'ocrHandle', // 合格证
    }
    return obj[card]
}

/**
 * 
 * @param {*} newOcrSwitch 开关
 * @param {*} key ocr返回的字段
 * @param {*} isCertificateLicence 是否合格证
 */
export const getOcrKey = (newOcrSwitch, key) => {
    const obj = {
        licenseNo: newOcrSwitch ? 'plateNo' : 'licenseNo', // 车牌号
        frameNo: newOcrSwitch ? 'vin' : 'frameNo', // 车架号
        brandName: newOcrSwitch ? 'model' : 'brandName', // 车型
        singeinDate: newOcrSwitch ? 'registerDate' : 'singeinDate', // 注册日期
        identifyNumber: newOcrSwitch ? 'id_number' : 'idNumber', // 身份证号
        birthday: newOcrSwitch ? 'birth' : 'birthday', // 出生日期
        identifyExpiry: newOcrSwitch ? 'validate_date' : 'validity' // 证件有效期
    }
    return obj[key]
}
/**
 * 
 * @param {*} newOcrSwitch 开关
 * @param {*} key ocr返回的字段
 * @param {*} isCertificateLicence 是否合格证
 */
export const getOcrKeyNew = (newOcrSwitch, key, isCertificateLicence) => {
    const obj = {
        licenseNo: isCertificateLicence ? 'licenseNo' : newOcrSwitch ? 'plateNo' : 'licenseNo', // 车牌号
        frameNo: isCertificateLicence ? 'certificationModelVin' : newOcrSwitch ? 'vin' : 'frameNo', // 车架号
        brandName: isCertificateLicence ? 'certificationVehicleBrand' : newOcrSwitch ? 'model' : 'brandName', // 车型
        singeinDate: isCertificateLicence ? 'singeinDate' : newOcrSwitch ? 'registerDate' : 'singeinDate', // 注册日期
        identifyNumber: newOcrSwitch ? 'idNumber' : newOcrSwitch ? 'id_number' : 'idNumber', // 身份证号
        birthday: isCertificateLicence ? 'birthday' : newOcrSwitch ? 'birth' : 'birthday', // 出生日期
        identifyExpiry: isCertificateLicence ? 'validity' : newOcrSwitch ? 'validate_date' : 'validity', // 证件有效期
        engineNo: isCertificateLicence ? 'certificationEngineNumber' : 'engineNo', // 发动机号
        issueDate: isCertificateLicence ? 'certificationIssueDate' : 'issueDate' // 发证日期
    }
    return obj[key]
}
/**
     * 掩码
     * @param {String} str 掩码内容
     * @param {String} type 掩码类型
     * @returns String
     */
export const mask = (str, type) => {
    if (!str || !type) return ''
    switch (type) {
        case 'mobile': // 手机号
            return str.substr(0, 3) + '****' + str.substr(7)
        case 'card': // 身份证
            let x = str.length > 15 ? '**************' : '***********'
            return str.substr(0, 2) + x + str.substr(str.length - 2)
        case 'name':  // 姓名
            if (str.length > 2) { // 姓名大于两位汉字，需保留最后两位，例：*小明
                let result = str.substr(0, str.length - 2)
                let lastStr = str.substr(str.length - 2)
                let firstStr = ''
                for (let i = 0; i < result.length; i++) {
                    firstStr += '*'
                }
                return firstStr + lastStr
            } else {
                return str.replace(/^(.)(.{1})/, '*$2')
            }
        case 'email': // 邮件
            let firstSt = str.substring(0, 3)
            let lastStr = str.includes("@") ? str.substring(str.indexOf("@"), str.length) : ""
            return firstSt + "*****" + lastStr
        case 'address': // 地址
            let reg = /((0|[1-9]\d*)(\.\d+)?)/g;
            let regNum = /\d/g;
            let repStr = '**';
            return str.match(regNum) ? str.replace(reg, repStr) : str.substring(0, str.length - 3) + repStr
        case "carNo": // 车牌号
            // 特殊处理*-*的情况
            const licensePlateRegexT = /^(\*-\*|\*_\*)$/  // 正则表达式，用于匹配 '*-*' 和 '*_*'
            const licensePlateRegexG = /(\\*-\\*)|(\\*_\\*)/g  // 正则表达式，用于全局匹配 '*-*' 和 '*_*'
            if (licensePlateRegexT.test(str)) {
                // *-*直接返回
                return str
            } else {
                str = str.replace(licensePlateRegexG, '');  // 将 '*-*' 和 '*_*' 替换为空字符串
            }
            let numBegin = str.substring(0, 2);
            let numEnd = str.substring(str.length - 2);
            return numBegin + "***" + numEnd;
        case "frameNo": // 车架号
            let frameStart = str.substring(0, 2);
            let frameEnd = str.substring(str.length - 3);
            return frameStart + "************" + frameEnd;
        case "engineNo": // 发动机号
            if (str) {
                let start = str.substring(0, 2);
                let end = str.substring(str.length - 3);
                return `${start}${"*".repeat(str.length - 5)}${end}`;  // 使用'*'填充中间的字符
            }
    }
}

/**
 * [getParams 获取url参数，转换成对象]
 * @param  {string} url [支持传自己的url，没有则去window.location下的]
 */
export const getParams = (url) => {
    var url = url ? url : window.location.href;
    if (url.indexOf('#') > -1) {
        url = url.split('#')[1];
    }
    var variable = url.split('?')[1];
    if (!variable) {
        return null;
    } else {
        var value = {};
        variable = decodeURIComponent(variable).split('&');
        for (var i = 0, m = variable.length; i < m; i++) {
            var tempv = variable[i].split('=')[1];
            if (typeof (tempv) != 'undefined') {
                if (tempv == 'null' || tempv == 'undefined') {
                    tempv = '';
                }
                tempv = decodeURIComponent(tempv).replace(/</g, '&lt;').replace(/>/g, '&gt;');
                value[variable[i].split('=')[0]] = tempv;
            }
        }
        return value;
    }
};
//jqxClassId 转 carKindCodeShow
export const CLASSIDTOCARKINDSHOW = {
    "KA": "11",//六座以下客车
    "KB": "12",//六座至十座以下客车
    "KC": "13",//十座至二十座以下客车
    "KD": "14",//二十座至三十六座以下客车
    "KE": "15",//三十六座及三十六座以上客车
    "HA": "21",//二吨以下货车
    "HB": "22",//二吨至五吨以下货车
    "HC": "23",//五吨至十吨以下货车
    "HD": "24",//十吨以上货车
    "GA": "25",//二吨以下挂车
    "GB": "26",//二吨至五吨以下挂车
    "GC": "27",//五吨至十吨以下挂车
    "GD": "28", //十吨以上挂车
    "HE": "93", //低速货车
    "HF": "94", //三轮汽车
    "ZA": "30", //特种车一：油罐车、气罐车、液罐车、冷藏车
    "ZB": "40", //特种车二：用于牵引、清障、清扫、清洁、起重、装卸、升降、搅拌、挖掘、推土等的各种专用机动车
    "ZC": "50", //特种车三：装有固定专用仪器设备从事专业工作的监测、消防、医疗、电视转播等的各种专用机动车
    "ZD": "60" //特种车四：集装箱拖头
}
// 车辆类型 编码to中文
export const CARTYPECODETONAME = {
    11: "六座以下客车",
    12: "六座至十座以下客车",
    13: "十座至二十座以下客车",
    14: "二十座至三十六座以下客车",
    15: "三十六座及三十六座以上客车",
    21: "二吨以下货车",
    22: "二吨至五吨以下货车",
    23: "五吨至十吨以下货车",
    24: "十吨以上货车",
    25: "二吨以下挂车",
    26: "二吨至五吨以下挂车",
    27: "五吨至十吨以下挂车",
    28: "十吨以上挂车",
    93: "低速货车",
    94: "三轮汽车",
}
export const VEHICLECATEGORY = {
    '21': {
        'H32': '轻型厢式货车H32',
    },
    '22': {
        'H22': '中型厢式货车H22',
    },
    '23': {
        'H22': '中型厢式货车H22',
    },
    '24': {
        'H12': '重型厢式货车H12',
    },
    '25': {
        'B31': '轻型普通半挂车B31',
    },
    '26': {
        'B21': '中型普通半挂车B21',
    },
    '27': {
        'B21': '中型普通半挂车B21',
    },
    '28': {
        'B11': '重型普通半挂车B11',
    },
}

/**
* 18位统一社会信用代码校验(含末位校验)
* @returns 返回是否符合规则
*/
export const unifiedSocialCreditCode = () => {
    var obj = {}
    obj.firstarray = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
    ]
    obj.firstkeys = [3, 7, 9, 10, 5, 8, 4, 2]
    obj.secondarray = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'J',
        'K',
        'L',
        'M',
        'N',
        'P',
        'Q',
        'R',
        'T',
        'U',
        'W',
        'X',
        'Y',
    ]
    obj.secondkeys = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28]
    obj.verify = function (str) {
        var code = str.toUpperCase()
        /*
        统一社会信用代码由十八位的阿拉伯数字或大写英文字母（不使用I、O、Z、S、V）组成。
         第1位：登记管理部门代码（共一位字符）
         第2位：机构类别代码（共一位字符）
         第3位~第8位：登记管理机关行政区划码（共六位阿拉伯数字）
         第9位~第17位：主体标识码（组织机构代码）（共九位字符）
         第18位：校验码​（共一位字符）
        */
        if (code.length !== 18) {
            return false
        }
        var reg = /^\w\w\d{6}\w{9}\w$/
        if (!reg.test(code)) {
            return false
        }
        /*
            登记管理部门代码：使用阿拉伯数字或大写英文字母表示。​
            机构编制：1​
            外交：2
            司法行政：3
            文化：4
            民政：5​
            旅游：6
            宗教：7
            工会：8
            工商：9​
            中央军委改革和编制办公室：A
            农业：N
            其他：Y
         */
        reg = /^[1,2,3,4,5,6,7,8,9,A,N,Y]\w\d{6}\w{9}\w$/
        if (!reg.test(code)) {
            return false
        }
        /*
            机构类别代码：使用阿拉伯数字或大写英文字母表示。​
            机构编制机关：11打头​​
            机构编制事业单位：12打头​
            机构编制中央编办直接管理机构编制的群众团体：13打头​​
            机构编制其他：19打头​
            外交外国常驻新闻机构：21打头​​
            外交其他：29打头​​
            司法行政律师执业机构：31打头​​
            司法行政公证处：32打头​​
            司法行政基层法律服务所：33打头​​
            司法行政司法鉴定机构：34打头​​
            司法行政仲裁委员会：35打头​​
            司法行政其他：39打头​​
            文化外国在华文化中心：41打头​​
            文化其他：49打头​​
            民政社会团体：51打头​
            民政民办非企业单位：52打头​
            民政基金会：53打头​
            民政其他：59打头​
            宗教宗教活动场所：61打头​
            宗教院校：62打头​
            宗教其他：69打头​
            工会其他：71打头​
            工会其他：79打头​
            工商企业：91打头​
            工商个体工商户：92打头​
            工商农民专业合作社：93打头​
            中央军委改革和编制办公室军队事业单位：A1打头​
            中央军委改革和编制办公室其他：A9打头​
            农业组级集体经济组织：N1打头​
            农业村级集体经济组织：N2打头​
            农业乡镇级集体经济组织：N3打头​
            农业其他：N9打头​
            其他：Y1打头​
        */
        reg = /^(11|12|13|19|21|29|31|32|33|34|35|39|41|49|51|52|53|54|59|61|62|69|71|72|79|81|89|91|92|93|A1|A9|N1|N2|N3|N9|Y1)\d{6}\w{9}\w$/
        if (!reg.test(code)) {
            return false
        }
        /*
             主体标识码（组织机构代码）：使用阿拉伯数字或英文大写字母表示。按照GB 11714编码。
             在实行统一社会信用代码之前，以前的组织机构代码证上的组织机构代码由九位字符组成。格式为XXXXXXXX-Y。前面八位被称为“本体代码”；最后一位被称为“校验码”。校验码和本体代码由一个连字号（-）连接起来。以便让人很容易的看出校验码。但是三证合一后，组织机构的九位字符全部被纳入统一社会信用代码的第9位至第17位，其原有组织机构代码上的连字号不带入统一社会信用代码。
             原有组织机构代码上的“校验码”的计算规则是：​
             例如：某公司的组织机构代码是：59467239-9。那其最后一位的组织机构代码校验码9是如何计算出来的呢？
             第一步：取组织机构代码的前八位本体代码为基数。5 9 4 6 7 2 3 9
             提示：如果本体代码中含有英文大写字母。则A的基数是10，B的基数是11，C的基数是12，依此类推，直到Z的基数是35。
             第二步：​​取加权因子数值。因为组织机构代码的本体代码一共是八位字符。则这八位的加权因子数值从左到右分别是：3、7、9、10、5、8、4、2。​
             第三步：本体代码基数与对应位数的因子数值相乘。​
             5×3＝15，9×7＝63，4×9＝36，6×10＝60，
             7×5＝35，2×8＝16，3×4=12，9×2＝18​​
             第四步：将乘积求和相加。​
             15+63+36+60+35+16+12+18=255
             第五步：​将和数除以11，求余数。​​
             255÷11=33，余数是2。​​
          */
        var firstkey = obj.calc(code.substr(8), obj.firstarray, obj.firstkeys, 11)
        /*
         第六步：用阿拉伯数字11减去余数，得求校验码的数值。当校验码的数值为10时，校验码用英文大写字母X来表示；当校验码的数值为11时，校验码用0来表示；其余求出的校验码数值就用其本身的阿拉伯数字来表示。​
         11-2＝9，因此此公司完整的组织机构代码为 59467239-9。​​
        */
        var firstword
        if (firstkey < 10) {
            firstword = String(firstkey)
        }
        if (firstkey === 10) {
            firstword = 'X'
        } else if (firstkey === 11) {
            firstword = '0'
        }
        if (firstword !== code.substr(16, 1)) {
            return false
        }
        /*
            校验码：使用阿拉伯数字或大写英文字母来表示。校验码的计算方法参照 GB/T 17710。
            例如：某公司的统一社会信用代码为91512081MA62K0260E，那其最后一位的校验码E是如何计算出来的呢？
            第一步：取统一社会信用代码的前十七位为基数。9 1 5 1 2 0 8 1 21 10 6 2 19 0 2 6 0提示：如果前十七位统一社会信用代码含有英文大写字母（不使用I、O、Z、S、V这五个英文字母）。则英文字母对应的基数分别为：A=10、B=11、C=12、D=13、E=14、F=15、G=16、H=17、J=18、K=19、L=20、M=21、N=22、P=23、Q=24、R=25、T=26、U=27、W=28、X=29、Y=30​
            第二步：​​取加权因子数值。因为统一社会信用代码前面前面有十七位字符。则这十七位的加权因子数值从左到右分别是：1、3、9、27、19、26、16、17、20、29、25、13、8、24、10、30、2​8
            第三步：基数与对应位数的因子数值相乘。​
            9×1=9，1×3=3，5×9=45，1×27=27，2×19=38，0×26=0，8×16=128​
            1×17=17，21×20=420，10×29=290，6×25=150，2×13=26，19×8=152​
            0×23=0，2×10=20，6×30=180，0×28=0
            第四步：将乘积求和相加。​9+3+45+27+38+0+128+17+420+290+150+26+152+0+20+180+0=1495
            第五步：​将和数除以31，求余数。​​
            1495÷31=48，余数是17。​​
        */
        var secondkey = obj.calc(code, obj.secondarray, obj.secondkeys, 31)
        /*
         第六步：用阿拉伯数字31减去余数，得求校验码的数值。当校验码的数值为0~9时，就直接用该校验码的数值作为最终的统一社会信用代码的校验码；如果校验码的数值是10~30，则校验码转换为对应的大写英文字母。对应关系为：A=10、B=11、C=12、D=13、E=14、F=15、G=16、H=17、J=18、K=19、L=20、M=21、N=22、P=23、Q=24、R=25、T=26、U=27、W=28、X=29、Y=30
         因为，31-17＝14，所以该公司完整的统一社会信用代码为 91512081MA62K0260E。​​
        */
        var secondword = obj.secondarray[secondkey]
        if (!secondword || secondword !== code.substr(17, 1)) {
            return false
        }
        var word = code.substr(0, 16) + firstword + secondword
        if (code !== word) {
            return false
        }
        return true
    }
    obj.calc = function (code, array1, array2, b) {
        var count = 0
        for (var i = 0; i < array2.length; i++) {
            var a = code[i]
            count += array2[i] * array1.indexOf(a)
        }
        var remainder = count % b
        return remainder === 0 ? 0 : b - remainder
    }
    return obj
}

// 获取影像token所需的目录信息类型映射，1-投保人、2-被保险人、3-受益人、4-车主、5-车
export const IMAGE_ITEM_TYPE_MAP = new Map([
    ['applicant', '1'],
    ['insured', '2'],
    ['beneficiary', '3'],
    ['owner', '4'],
    ['vehicle', '5'],
])

/**
 * 创建目录信息项
 * @param obj 数据对象
 * @param type 信息类型
 */
export const createImageItem = (obj, type) => {
    const { name, identifyType, identifyNumber, licenseNo, frameNo } = obj
    if (type === '5') {
        // 5-车
        return {
            itemName: licenseNo,
            itemNumber: frameNo,
            type,
        }
    } else {
        // 1-投保人、2-被保险人、3-受益人、4-车主
        return {
            itemName: name,
            itemNumber: identifyNumber,
            itemType: identifyType,
            type,
        }
    }
}

/**
 * 创建目录信息列表
 * @param quoteInfo 报价信息对象
 * @param types 需要处理的类型列表
 * @returns baseInfo 目录信息列表
 */
export const createImageItemInfos = (quoteInfo, types) => {
    const baseInfo = []
    types.forEach((item) => {
        const type = IMAGE_ITEM_TYPE_MAP.get(item)
        const obj = quoteInfo && quoteInfo[item]
        if (!type || !obj) {
            return
        }
        baseInfo.push(createImageItem(obj, type))
    })
    return baseInfo
}


export const isEmpty = (object) => {
    if ((object === null
        || typeof (object) === "undefined")
        || (typeof (object) === "string" && object === "" && object !== undefined)
        || (typeof (object) === 'object' && object.length === 0)) {
        return true;
    } else if (typeof (object) === "string" && object.length > 0) {
        return false;
    }
    else if (Object.keys(object).length === 0) {
        return true;
    }
    else {
        return false;
    }
}
export class LicensePlateHelper {
    vehicle;
    constructor(vehicle) {
        this.vehicle = vehicle;
    }
    PlateColor = {
        Black: '02',//'黑',
        Yellow: '04',//'黄',
        White: '03',//'白',
        Blue: '01',//'蓝',
        GreenYellow: '07',//'黄绿',
        GradientGreen: '06',//'渐变绿',
        Other: '99',//'其他',
    }
    // 100客车 200货车 300特种车 400摩托车 500拖拉机
    carKindCodeArr = ['100', '200', '300', '400', '500'];
    automobileCodeArr = ['100', '200', '300'];
    specCodeArr = ['200', '300']
    isDiplomaticPlate(plate) {
        return plate.includes('使');
    }
    isConsularPlate(plate) {
        return plate.includes('领');
    }
    isTrainingPlate(plate) {
        return plate.includes('学');
    }
    isTestPlate(plate) {
        return plate.includes('试');
    }
    isTrailerPlate(plate) {
        return plate.includes('挂');
    }
    isPolicePlate(plate) {
        return plate.includes('警');
    }
    isHKPlate(plate) {
        return plate.includes('港');
    }
    isMacaoPlate(plate) {
        return plate.includes('澳');
    }
    isWJPlate(plate) {
        return plate.includes('WJ');
    }
    isEmergencyPlate(plate) {
        return plate.includes('应急');
    }
    isTempPlate(plate) {
        return plate.includes('LS');
    }
    isMoto(carKindCode) {
        return carKindCode === '400';
    }
    getPlateColor() {
        // console.log('车辆信息this.vehicle-=-=-=-',JSON.parse(JSON.stringify(this.vehicle)))
        let { licenseNo, carKindCode, carKindCodeShow, newEnergyFlag, tonCount, seatCount, completeKerbMass, brandName, maxDesignSpeed, exhaustScale, power } = this.vehicle;
        // console.log('车辆种类-=-=-=-',carKindCode)
        // console.log('车牌号-=-=-=-',licenseNo)
        // var licenseNo = vehicle.licenseNo  // 车牌
        // var carKindCode = vehicle.carKindCode // 车辆种类
        // var carKindCodeShow = vehicle.carKindCodeShow  // 车辆类型
        // var newEnergyFlag = vehicle.newEnergyFlag  // 是否新能源车
        // var tonCount = vehicle.tonCount // 核定载质量
        // var seatCount = vehicle.seatCount // 核定载客数
        // var completeKerbMass = vehicle.completeKerbMass // 整备质量
        // var brandName = vehicle.brandName // 厂牌型号
        // var maxDesignSpeed = vehicle.maxDesignSpeed // 最高设计时速
        // var exhaustScale = vehicle.exhaustScale // 排量
        // var power = vehicle.power // 功率
        if (this.isDiplomaticPlate(licenseNo)) {
            if (this.isMoto(carKindCode)) {
                return {
                    licenseTypeCode: '09',
                    licenseColorCode: this.PlateColor.Black,
                }
            } else if (this.automobileCodeArr.includes(carKindCode)) {
                return {
                    licenseTypeCode: '03',
                    licenseColorCode: this.PlateColor.Black,
                }
            }
        }
        if (this.isConsularPlate(licenseNo)) {
            if (this.isMoto(carKindCode)) {
                return {
                    licenseTypeCode: '10',
                    licenseColorCode: this.PlateColor.Black,
                }
            } else if (this.automobileCodeArr.includes(carKindCode)) {
                return {
                    licenseTypeCode: '04',
                    licenseColorCode: this.PlateColor.Black,
                }
            }
        }
        if (this.isTrainingPlate(licenseNo)) {
            if (this.isMoto(carKindCode)) {
                return {
                    licenseTypeCode: '17',
                    licenseColorCode: this.PlateColor.Yellow,
                }
            } else if (this.automobileCodeArr.includes(carKindCode)) {
                return {
                    licenseTypeCode: '16',
                    licenseColorCode: this.PlateColor.Yellow,
                }
            }
        }
        if (this.isTestPlate(licenseNo)) {
            if (this.isMoto(carKindCode)) {
                return {
                    licenseTypeCode: '19',
                    licenseColorCode: this.PlateColor.Yellow,
                }
            } else if (this.automobileCodeArr.includes(carKindCode)) {
                return {
                    licenseTypeCode: '18',
                    licenseColorCode: this.PlateColor.Yellow,
                }
            }
        }
        if (this.isPolicePlate(licenseNo)) {
            if (this.isMoto(carKindCode)) {
                return {
                    licenseTypeCode: '24',
                    licenseColorCode: this.PlateColor.White,
                }
            } else if (this.automobileCodeArr.includes(carKindCode)) {
                return {
                    licenseTypeCode: '23',
                    licenseColorCode: this.PlateColor.White,
                }
            }

        }
        if (this.isTrailerPlate(licenseNo) && this.specCodeArr.includes(carKindCode)) {
            return {
                licenseTypeCode: '15',
                licenseColorCode: this.PlateColor.Yellow,
            }
        }
        if (this.isHKPlate(licenseNo)) return {
            licenseTypeCode: '26',
            licenseColorCode: this.PlateColor.Black,
        }
        if (this.isMacaoPlate(licenseNo)) return {
            licenseTypeCode: '27',
            licenseColorCode: this.PlateColor.Black,
        }
        if (this.isWJPlate(licenseNo)) return {
            licenseTypeCode: '31',
            licenseColorCode: this.PlateColor.White,
        }
        if (this.isEmergencyPlate(licenseNo)) return {
            licenseTypeCode: '33',
            licenseColorCode: this.PlateColor.White,
        }
        if (this.isTempPlate(licenseNo)) return {
            licenseTypeCode: '22',
            licenseColorCode: this.PlateColor.Blue,
        }
        // carKindCodeShow  93  低速货车
        // 车牌号不包含使，领，挂，学，试，警，港，澳，应急，车牌号不以WJ、LS开头，车辆种类为客车、货车（不含低速货车），特种车，能源种类为非新能源车，且满足以下任意一个条件：
        // 1、客车、货车、特种车：车辆外形尺寸总长（数据来源于车型车价）≥6米；
        // 2、客车：核定载客数（核心）>9；
        // 3、货车、特种车：【整备质量（核心）+核定载质量（核心）】>4500kg。
        if (carKindCodeShow !== '93' && this.automobileCodeArr.includes(carKindCode)) {
            let flag = (carKindCode === '100' && !isNaN(Number(seatCount)) && Number(seatCount) > 9) || (this.specCodeArr.includes(carKindCode) && (Number(tonCount) + Number(completeKerbMass)) > 4500)
            if (flag) {
                if (newEnergyFlag !== '1') {
                    return {
                        licenseTypeCode: '01',
                        licenseColorCode: this.PlateColor.Yellow,
                    }
                } else {
                    return {
                        licenseTypeCode: '51',
                        licenseColorCode: this.PlateColor.GreenYellow,
                    }
                }
            }
            // 小型车  上面条件不满足 执行到这里，就代表是小型车
            if (newEnergyFlag !== '1') {
                return {
                    licenseTypeCode: '02',
                    licenseColorCode: this.PlateColor.Blue,
                }
            } else {
                return {
                    licenseTypeCode: '52',
                    licenseColorCode: this.PlateColor.GradientGreen,
                }
            }
        }
        if (carKindCode === '400') {
            // 摩托车
            let flag = (!isNaN(Number(maxDesignSpeed)) && Number(maxDesignSpeed) > 50)
                || (!isNaN(Number(exhaustScale)) && Number(exhaustScale) > 50)
                || (!isNaN(Number(power)) && Number(power) > 4)
            if (flag) {
                return {
                    licenseTypeCode: '07',
                    licenseColorCode: this.PlateColor.Yellow,
                }
            }
            let flag1 = (!isNaN(Number(maxDesignSpeed)) && Number(maxDesignSpeed) <= 50)
                || (!isNaN(Number(exhaustScale)) && Number(exhaustScale) <= 50)
                || (!isNaN(Number(power)) && Number(power) <= 4)
            if (flag1) {
                return {
                    licenseTypeCode: '08',
                    licenseColorCode: this.PlateColor.Blue,
                }
            }
        }

        let regex = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]\d{2}$/
        // /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]\d{2}[A-Z0-9]*$/
        if (licenseNo && licenseNo.slice(0, 3).match(regex) && carKindCode === '500') {
            if ((brandName.includes('低速') || brandName.includes('三轮'))) {
                return {
                    licenseTypeCode: '13',
                    licenseColorCode: this.PlateColor.Yellow,
                }
            } else {
                return {
                    licenseTypeCode: '14',
                    licenseColorCode: this.PlateColor.Other,
                }
            }

        }

        return {
            licenseTypeCode: '',
            licenseColorCode: '',
        }
    }
}
// todo 选择号牌种类的时候
export const transLicenseColorCode = (code) => {
    let licenseColor = '';
    // console.log('code', code)
    switch (code) {
        case '01':
        case '07':
        case '13':
        case '15':
        case '16':
        case '17':
        case '18':
        case '19': licenseColor = '04'; break;
        case '03':
        case '04':
        case '09':
        case '10':
        case '12':
        case '26':
        case '27': licenseColor = '02'; break;
        case '02':
        case '08':
        case '22': licenseColor = '01'; break;
        case '20':
        case '21':
        case '23':
        case '24':
        case '31':
        case '32':
        case '33': licenseColor = '03'; break;
        case '51': licenseColor = '07'; break;
        case '52': licenseColor = '06'; break;
        case '14': licenseColor = '99'; break;
    }
    return licenseColor;
}
// 页面添加水印效果
const setWatermark = (str) => {
	const id = '1.23452384164.123412416';
	if (document.getElementById(id) !== null) document.body.removeChild(document.getElementById(id));
	const can = document.createElement('canvas');
	can.width = 200;
	can.height = 150;
	const cans = can.getContext('2d');
	cans.font = '14px Vedana';
	cans.fillStyle = 'rgba(0, 0, 0, 0.1)';
	cans.textBaseline = 'middle';
    // 计算文本宽度
    const textWidth = cans.measureText(str).width;
    // 确保水印不溢出
    const padding = 10; // 设置边距
    const xOffset = Math.max(padding, (can.width - textWidth) / 2);
    const yOffset = can.height / 2;
    // 旋转水印
    cans.translate(xOffset, yOffset); // 移动到适当的位置
    cans.rotate((-20 * Math.PI) / 180);
	cans.fillText(str, 0, 0);
	const div = document.createElement('div');
	div.id = id;
	div.style.pointerEvents = 'none';
	div.style.top = '0px';
	// div.style.left = '0px';
	div.style.position = 'fixed';
	div.style.zIndex = '10000000';
	div.style.width = `${document.documentElement.clientWidth}px`;
	div.style.height = `${document.documentElement.clientHeight}px`;
	div.style.background = `url(${can.toDataURL('image/png')}) left top repeat`;
	document.body.appendChild(div);
	return id;
};

export const watermark = {
	// 设置水印
	set: (str) => {
		let id = setWatermark(str);
		if (document.getElementById(id) === null) id = setWatermark(str);
	},
	// 删除水印
	del: () => {
		let id = '1.23452384164.123412416';
		if (document.getElementById(id) !== null) document.body.removeChild(document.getElementById(id));
	},
}
// 需要加水印的页面
export const waterMarkPath = [
    '/base_msg',
    '/base_image',
    '/base_msg_ocr',
    '/base_msg_hc',
    '/base_msg_sd',
    '/owner_same',
    // 报价
    '/owner_same_hc',
    '/owner_same_sd',
    '/owner_same_ocr',
    '/occupation_list',
    '/occupation_list_new',
    '/business_list',
    '/holder_msg',
    '/vehicle_model',
    '/vehicle_select',
    '/adujust_insurance',
    '/adujust_insurance_energy',
    '/charging_pile',
    '/submit_order',
    '/submit_order/InstructionNew',
    '/upload_img',
    '/payorder',
    '/elecpage',
    '/privacy',
]
export const getWaterMarkName = (str) => {
    let waterMarkName = '';
    waterMarkName = str;
    if (!waterMarkName) return ''
    if (waterMarkName.includes('@')) {
        waterMarkName = waterMarkName.split('@')[0] || '';
        const date = format(new Date(), 'yyyy-MM-dd')
        return waterMarkName + '-' + date
    } else {
        return waterMarkName
    }
}
export default {
    createImageItemInfos,
    createImageItem,
    unifiedSocialCreditCode,
    getOcrKey,
    getOcrKeyNew,
    getOcrUrlName,
    getPostFix,
    isPostfixImg,
    checkAddress,
    getIdCardInfo,
    yearsBetween,
    beautyFormatDate,
    recTodayDate,
    recNexDate,
    recNexDateSpecial,
    deepClone,
    nullOrStringify,
    stringParsedTime,
    isWeiXin,
    qqMapGeolocation,
    name2value,
    mergeObj,
    mergeCarBeans,
    mergeVehicle,
    daysBetween,
    translateTimeDate,
    limitToPercent,
    formatSingeinDate,
    textTrim,
    startVideo,
    stopVideo,
    createOperationVideo,
    oneClickRenewal,
    formatYhCard,
    webviewAction,
    webviewGoBack,
    openHuiyuanchengzhang,
    webviewMyPerformance,
    webviewOrderList,
    webviewCheckIn,
    webviewPrint,
    webviewOrderToPay,
    webviewPolicyDelivery,
    nativeAutoLogin,
    nativeShare,
    nativeOpenPage,
    assign,
    assigns,
    suggestions,
    watchPropertyChange,
    loadAMAP,
    isInNewApp,
    isInOldApp,
    isOldAppPage,
    isNewAppPage,
    isInApp,
    isFromNewApp,
    getDateYearSub,
    transDate,
    isHaApp,
    setOtherInfo,
    checkAuditTime,
    VEHICLECATEGORY,
    isEmpty,
    transLicenseColorCode,
    LicensePlateHelper,
    countEndDate,
    getWaterMarkName,
    waterMarkPath,
    watermark,
};
